import { render } from "./ExchangeConfirm.vue?vue&type=template&id=6449fd2c"
import script from "./ExchangeConfirm.vue?vue&type=script&lang=js"
export * from "./ExchangeConfirm.vue?vue&type=script&lang=js"

import "./ExchangeConfirm.vue?vue&type=style&index=0&id=6449fd2c&lang=css"

import exportComponent from "D:\\project\\lm-pgac\\PGAC-source\\pgac-600090-ob-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__